export class LicenseConstants {
    static active = 'Active';
    static expired = 'Expired';
    static inactive = 'Inactive';
    static licenseInfoBaseUrl = 'https://appcloud.relationshipone.com/app/';
}
